const data = {
  SITE_KEY: "6Lf6NHUiAAAAAFsRLhwEbkNtwy8ffvoRPh4GiG6n",
  API_URL: " https://www.productintegrity.solutions",
};
export default data;
